import * as ActionTypes from '../constants/actionTypes';
import { ApplicationFormState, PlanHolder, Beneficiary } from '../models/applicationForm';

const applicationFormReducer = (state: ApplicationFormState = {} as any, action: any) => {
  switch(action.type) {
    case ActionTypes.UPDATE_LOCAL_PLANHOLDER:
      return {
        ...state,
        planholder: action.planholder as PlanHolder
      };
    case ActionTypes.UPDATE_LOCAL_BENEFICIARY:
      return {
        ...state,
        beneficiary: action.beneficiary as Beneficiary
      };
    default:
      return state;
  }
}

export default applicationFormReducer;